/// <amd-module name="Build/Common/Library/PipelineTriggerSettings" />
import { PipelineTriggerSettings } from "Build/Client/Contracts/Build";

export enum ForkProtectionOption {
    None = "None",
    Disabled = "Disabled",
    BestPractice = "BestPractice",
    Custom = "Custom"
}

/**
 * Require comment for the build to trigger on pull request created
 */
export enum CommentTriggerOption {
    /**
     * Comment is required for all users except team members and contributors
     */
    NonTeamMembersNonContributor = "NonTeamMembersNonContributor",
    /**
     * Comment is required for all users except team members
     */
    NonTeamMembers = "NonTeamMembers",
    /**
     * Comment is required for all users
     */
    All = "All",
}

export const DisabledSettings: PipelineTriggerSettings = {
    forkProtectionEnabled: true,
    buildsEnabledForForks: false,
    enforceJobAuthScopeForForks: false,
    enforceNoAccessToSecretsFromForks: false,
    isCommentRequiredForPullRequest: false,
    requireCommentsForNonTeamMembersOnly: false,
    requireCommentsForNonTeamMemberAndNonContributors: false,
};

export const BestPracticeSettings: PipelineTriggerSettings = {
    forkProtectionEnabled: true,
    buildsEnabledForForks: true,
    enforceJobAuthScopeForForks: true,
    enforceNoAccessToSecretsFromForks: true,
    isCommentRequiredForPullRequest: true,
    requireCommentsForNonTeamMembersOnly: false,
    requireCommentsForNonTeamMemberAndNonContributors: false,
};
